<template>
  <div>
    <div class="d-flex flex-row pb-3 pt-2" :style="`justify-content:${options.theme === 'default' ? 'space-between' : 'left'};`">
      <div class="d-flex flex-column">
        <div class="d-flex flex-row">
          <p class="mb-0 pt-3 pr-2" v-if="options.theme === 'default'">Activating Date - </p>
          <v-text-field
            class="edit-date-box"
            v-model="activatingDate"
            outlined
            dense
            hide-details
            @input="checkActDate(activatingDate)"
            @keyup.enter="checkActDate(activatingDate)"
          >
          </v-text-field>
          <div class="date-picker-inner">
            <date-picker
              className="input-field"
              :options="{theme: 'icon', confirm: true}"
              :status="actEndDateCal"
              @changeDate="setActDateFromPicker"
            />
          </div>
          <v-btn class="mt-1 secondary"  small :disabled="invalidActivatingDate" @click="saveActivatingDate()" v-if="options.theme === 'default'">
            <v-icon v-on="on" small>check</v-icon>
            Save
          </v-btn>
        </div>
        <div>
          <span class="text-danger ma-0 pt-1" v-if="invalidActivatingDate">Invalid Activating Date</span>
        </div>
      </div>
      <div class="d-flex flex-column">
        <div class="d-flex flex-row">
          <p class="mb-0 pt-3 pr-2" v-if="options.theme === 'default'">Review Meeting Date - </p>
          <v-text-field
            class="edit-date-box"
            v-model="reviewMeetingDate"
            outlined
            dense
            hide-details
            @input="checkDate(reviewMeetingDate)"
            @keyup.enter="checkDate(reviewMeetingDate)"
          >
          </v-text-field>
          <div class="date-picker-inner">
            <date-picker
              className="input-field"
              :options="{theme: 'icon', confirm: true}"
              :status="endDateCal"
              @changeDate="setDateFromPicker"
            />
          </div>
          &nbsp;<span :class="`pt-2 ${utils.func.getDaysDiff(reviewMeetingDate) < 0 ? 'text-red': ''}`" v-if="reviewMeetingDate && !invalidDate">({{utils.func.getDaysDiff(reviewMeetingDate)}})</span>
          <v-btn class="mt-1 secondary"  small :disabled="invalidDate" @click="saveChanges()" v-if="options.theme === 'default'">
            <v-icon v-on="on" small>check</v-icon>
            Save
          </v-btn>
        </div>
        <div>
          <span class="text-danger ma-0 pt-1" v-if="invalidDate">Invalid Meeting Date</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import utils from '@/utils'
import DatePicker from '@/components/scoped/custom/DatePicker'
// import moment from 'moment';
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'AddReviewMeetingDate',
  props: ['campaignID', 'oldReviewDate', 'oldActivatingDate', 'options'],
  components: {
    DatePicker
  },
  data() {
    return {
      reviewMeetingDate: '',
      activatingDate: '',
      invalidDate: false,
      invalidActivatingDate: false,
      utils
    }
  },
  computed: {
    ...mapState({
      reports: state => state.campaign.reports,
      savedReviewMeeting: state => state.campaignTimeline.savedReviewMeeting,
      savedTimeline: state => state.campaignTimeline.savedTimeline
    }),
    ...mapGetters('campaignTimeline', [
      'getReviewDates'
    ])
  },
  watch: {
    oldReviewDate(value) {
      this.reviewMeetingDate = value
      if (value) {
        this.checkDate(value, false)
      }
    },
    oldActivatingDate(value) {
      this.activatingDate = value
      if (value) {
        this.checkActDate(value)
      }
    }
  },
  mounted() {
    this.reviewMeetingDate = this.oldReviewDate
    if (this.reviewMeetingDate) {
      this.checkDate(this.reviewMeetingDate, false)
    }
  },
  methods: {
    checkDate(dateVal, forceSave = true) {
      this.invalidDate = true
      if (utils.func.isDateFormatValid(dateVal) || !dateVal) {
        this.invalidDate = false
        if (this.options.theme && this.options.theme === 'tableview' && forceSave) {
          this.saveChanges()
        }
      }
    },
    setDateFromPicker(value) {
      this.reviewMeetingDate = utils.func.formatCustomDate(value, 'DD/MM/YYYY')
      this.checkDate(this.reviewMeetingDate)
    },
    async saveChanges() {
      await this.$store.dispatch('campaign/getReportsByCampaignIDs', [this.campaignID])
      let reviewDates = this.getReviewDates(utils.func.parseDate(this.reviewMeetingDate), this.reports)
      const saveData = [{
        campaignID: this.campaignID,
        checkChgCol: 'ReviewMeetingDateCol',
        ...reviewDates
      }]
      let formData = new FormData()
      formData.append('data', JSON.stringify(saveData));
      await this.$store.dispatch('campaignTimeline/saveReviewMeeting', formData)
      if (this.savedReviewMeeting) {
        if (this.options.theme === 'default') {
          this.$swal({
            text: 'Successfully Saved.',
            type: 'success'
          })
        }
        this.$emit('updated', reviewDates)
      }
    },
    checkActDate(dateVal) {
      this.invalidActivatingDate = true
      if (utils.func.isDateFormatValid(dateVal) || !dateVal) {
        this.invalidActivatingDate = false
      }
    },
    setActDateFromPicker(value) {
      this.activatingDate = utils.func.formatCustomDate(value, 'DD/MM/YYYY')
      this.checkDate(this.activatingDate)
    },
    async saveActivatingDate() {
      let saveData = [{
        campaignID: this.campaignID,
        activatingDate: this.activatingDate
      }]
      let formData = new FormData()
      formData.append('data', JSON.stringify(saveData));
      await this.$store.dispatch('campaignTimeline/saveTimeline', formData)
      if (this.savedTimeline) {
        this.$swal({
          text: 'Successfully Saved.',
          type: 'success'
        })
        this.$emit('reloadTimeline')
      }
    }
  }
}
</script>
<style scoped>
  .edit-date-box {
    max-width: 200px;
  }
  .date-picker-inner {
    margin-left: -35px;
    padding-top: 3px;
  }
</style>



// WEBPACK FOOTER //
// AddReviewMeetingDate.vue?3f181fe4